import { cdnDomain } from "@/constants/cdnUrls";

/**
 * Havayolu logosu URL'i oluşturur
 * @param {string} airlineCode - Havayolu kodu (örn: "TK", "PC")
 * @returns {string|null} - Havayolu logosu URL'i veya null
 * @example
 * getAirlineLogoUrl("TK") // "https://cdn.turna.com/Images/Flight/Airlines/TK.png"
 */
export const getAirlineLogoUrl = (airlineCode) => {
  if (!airlineCode) return null;
  return `${cdnDomain}Images/Flight/Airlines/${airlineCode.toUpperCase()}.png`;
};

/**
 * Popüler havayolu logosu URL'i oluşturur
 * @param {string} airlineCode - Havayolu kodu (örn: "TK", "PC")
 * @returns {string|null} - Havayolu logosu URL'i veya null
 */
export const getPopularAirlinesLogoUrl = (airlineCode) => {
  if (!airlineCode) return null;
  return `${cdnDomain}saka/flight/airlines-widget/${airlineCode.toUpperCase()}.svg`;
};
